import React from 'react';

import { Row } from 'reactstrap';

import ContentContainer from 'components/ContentContainer/ContentContainer';
import DocumentColumn from 'components/ModularBlocks/DocumentsBlock/components/DocumentColumn';

import { CategoryWithDocumentsI, DocumentBlockI } from 'interfaces/content-stack/modular-blocks/documents';

export interface DocumentsBlockProps {
  className: string;
  data: DocumentBlockI;
}

function DocumentsBlock({ data, className }: DocumentsBlockProps) {
  if (!data) {
    return null;
  }

  const { categoryTitles, documents } = data;

  const docsByCategory: CategoryWithDocumentsI[] = [];
  categoryTitles.forEach((item) => {
    const categoryTitle = item?.title;
    const filteredDocs = documents.filter((v) => v.details?.subcategory === categoryTitle);

    categoryTitle && docsByCategory.push({ title: categoryTitle, docs: filteredDocs });
  });
  const sectionCount = docsByCategory.length;
  const colDivider = Math.round(sectionCount / 2);

  const firstCol: CategoryWithDocumentsI[] = [];
  const secondCol: CategoryWithDocumentsI[] = [];
  docsByCategory.forEach((item, index) => {
    if (index + 1 <= colDivider) {
      firstCol.push(item);
    } else {
      secondCol.push(item);
    }
  });

  return (
    <ContentContainer className={className}>
      <Row>
        {firstCol && <DocumentColumn data={firstCol} />}
        {secondCol && <DocumentColumn data={secondCol} />}
      </Row>
    </ContentContainer>
  );
}

export default DocumentsBlock;
